import { Button, Card, Row, Table } from "antd";
import { useFetchDataCount } from "../../../lib/hooks/useDefaultFetchDataCount";
import FillableFormsService from "../../../services/administration/fillableForms";
import { useFetchData } from "../../../lib/hooks/useDefaultFetchData";
import { IFillableFormListItem, TRequest } from "./types";
import { SimpleTablePagination } from "../../../components/SimpleTablePagination";
import { useTableColumns } from "./hooks/useTableColumns";
import { useOpenSidebar } from "./hooks/useOpenSidebar";
import { useDefualtOnRow } from "../../../lib/hooks/useDefaultOnRow";
import { createPortal } from "react-dom";
import { useCallback } from "react";

export const FillableForms = () => {
  const {
    request,
    isLoading: isCountLoading,
    total,
    onPageChange,
    fetchCount,
  } = useFetchDataCount<{}>(FillableFormsService, {}, [""], 50);

  const { isLoading, data, fetchData } = useFetchData<
    TRequest,
    IFillableFormListItem
  >(FillableFormsService, request);

  const reloadData = useCallback(() => {
    fetchData();
    fetchCount();
  }, [fetchCount, fetchData]);

  const { isShow, setOpenedItem, openSideBar, formWrapper } =
    useOpenSidebar(reloadData);

  const onNew = useCallback(() => setOpenedItem(null), [setOpenedItem]);

  const { onRow } = useDefualtOnRow(openSideBar);

  const { columns } = useTableColumns(setOpenedItem, reloadData);

  return (
    <Row className="w-100 h-100 pr-8 pl-2 py-6 card-table">
      <Card className="w-100 h-100">
        <Row className="w-100 justify-space-between mb-4">
          <h5 className="h h5 ant-table-title">Fillable Forms</h5>
          <Button shape="round" onClick={onNew}>
            Add New
          </Button>
        </Row>
        <p className="my-0 text-md title">
          Forms with description are visible in the portal.
        </p>
        <Row className="w-100 pt-6 d-block card-table__body">
          <Table
            className="w-100 h-100 clickable-rows-table small-table fillable-forms__table"
            dataSource={data}
            columns={columns}
            pagination={false}
            rowKey="id"
            loading={isLoading}
            onRow={onRow}
          />
          {total > 50 && (
            <SimpleTablePagination
              isLoading={isCountLoading}
              total={total}
              pageNumber={request.pageNumber}
              onPageChange={onPageChange}
              pageSize={request.pageSize}
            />
          )}
        </Row>
      </Card>

      {isShow && createPortal(formWrapper, document.body)}
    </Row>
  );
};
